export const NotFoundPagePTBRTranslations = {
  notFoundPageTitle: 'Página não encontrada',
  notFoundPageDescription:
    'Desculpe, não foi possível encontrar essa página. Verifique se o link está correto ou tente novamente mais tarde.',
};
